// Central API base URL. Override at build time with REACT_APP_API_URL.
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001";

export default API_BASE;
